import { RpmRun } from '../../store/RunTotal';
import { apiService } from '../APIService';

const API_SERVER_URL = process.env.REACT_APP_API_SERVER_URL;

export const getLatestRpmRun = () => {
  return apiService.callExternalApi<RpmRun>({
    url: `${API_SERVER_URL}/rpm-runs/latest`,
    method: 'GET',
    headers: { 'content-type': 'application/json' }
  });
};
